import { Tab, Tabs } from "@mui/material";
import classNames from "classnames";
import React from "react";

interface TabPanelProps {
  value: number;
  handleChange: (value: number) => void;
  options: Array<string>;
  customClassName?: string;
}
export const TabHeader = (props: TabPanelProps) => {
  const { value, handleChange, options, customClassName } = props;
  return (
    <>
      <Tabs
        value={value}
        onChange={(e, val) => handleChange(val)}
        aria-label="basic tabs example"
        TabIndicatorProps={{ sx: { display: "none" } }}
        className={customClassName}
        allowScrollButtonsMobile
        variant="scrollable"
      >
        {options.map((option, index) => (
          <Tab
            label={option}
            key={`options-${option}-index-${index}`}
            className={classNames(`!flex !flex-row gap-4 !border-0 !rounded-md`, {
              "!bg-tint": index === value,
            })}
            sx={{ px: 4 }}
          />
        ))}
      </Tabs>
      <div className="mt-3 mb-1 border-b border-border-token w-full"></div>

    </>
  );
};
